// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var section = BsCssJs$PrezzeeRibbon.merge([
      Theme__Typography$PrezzeeRibbon.Styles.body,
      BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(58))])
    ]);

var Style = {
  section: section
};

function VideoTextPromoBlock(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: Classnames([
                          section,
                          className$1
                        ])
                  })
            });
}

var Settings;

var MediaWrapper;

var TextWrapper;

var make = VideoTextPromoBlock;

export {
  Settings ,
  MediaWrapper ,
  TextWrapper ,
  Style ,
  make ,
}
/* section Not a pure module */
